<section class="relative group">
    <!-- Top controls ("add new section" button) -->

    @if(editMode){
        <white-label-section-controls
                *ngIf="editMode"
                [index]="index"
                (add)="addSection.emit($event - 1)"
                [position]="'top'">
        </white-label-section-controls>
        @switch (section.component){
            @case (componentTypes.hero) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" cdkDrag>
                    <app-header-stats-banner-component [componentModel]="section.data"></app-header-stats-banner-component>
                </app-section-component>
            }
            @case (componentTypes.banner_left_right) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-banner-left-right-component [componentModel]="section.data"></app-banner-left-right-component>
                </app-section-component>
            }


            @case (componentTypes.hero_live_stream) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-hero-banner-live-stream [componentModel]="section.data"  [section] = "section"></app-hero-banner-live-stream>
                </app-section-component>
            }
            @case (componentTypes.hero_simple_app) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-hero-banner-simple [componentModel]="section.data"></app-hero-banner-simple>
                </app-section-component>
            }
            @case (componentTypes.hero_product) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-hero-banner-product [componentModel]="section.data"></app-hero-banner-product>
                </app-section-component>
            }
            @case (componentTypes.hero_slider) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-hero-slider-banner [componentModel]="section.data"></app-hero-slider-banner>
                </app-section-component>
            }
            @case (componentTypes.hero_video) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-hero-video-banner [componentModel]="section.data"></app-hero-video-banner>
                </app-section-component>
            }



            @case (componentTypes.banner_right_left) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-banner-right-left-component [componentModel]="section.data"></app-banner-right-left-component>
                </app-section-component>
            }
            @case (componentTypes.sponsor) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-sponsors-component [componentModel]="section.data"></app-sponsors-component>
                </app-section-component>
            }
            @case (componentTypes.faq) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-dropdown-faq [componentModel]="section.data"></white-label-dropdown-faq>
                </app-section-component>
            }
            @case (componentTypes.latestProducts) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-store-preview [componentModel]="section.data"></app-store-preview>
                </app-section-component>
            }
            @case (componentTypes.text) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-text-reach-editor [componentModel]="section.data" [isEditing]="section === pageBuilderStore.sectionData"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.reviews) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-reviews-component [componentModel]="section.data"></app-reviews-component>
                </app-section-component>
            }
            @case (componentTypes.externalCode) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-text-reach-editor [componentModel]="section.data" [isEditing]="section === pageBuilderStore.sectionData"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.contactUs) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-contact-component [componentModel]="section.data"></app-contact-component>
                </app-section-component>
            }
            @case (componentTypes.aiComponent) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-text-reach-editor [componentModel]="section.data"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.pricing) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-pricing-component [componentModel]="section.data"></app-pricing-component>
                </app-section-component>
            }
            @case (componentTypes.stats) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-statistics [componentModel]="section.data"></white-label-statistics>
                </app-section-component>
            }
            @case (componentTypes.how_it_works) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-how-it-works [componentModel]="section.data"></white-label-how-it-works>
                </app-section-component>
            }
            @case (componentTypes.horizontalCarousel) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-horizontal-card-carousel [componentModel]="section.data"></white-label-horizontal-card-carousel>
                </app-section-component>
            }
            @case (componentTypes.grid) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <white-label-grid [componentModel]="section.data"></white-label-grid>
                </app-section-component>
            }
            @case (componentTypes.donationWidget) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" cdkDrag>
                    <app-donation-widget ></app-donation-widget>
                </app-section-component>
            }
            @default {
                <!-- Show "choose a section type" UI + "Delete"/"Save" buttons -->
                <div class="flex justify-between">
                    <h2 class="text-xl p-4 text-gray-300 text-center">
                        Select New Section Type
                    </h2>
                    <div class="flex justify-end gap-4">
                        <app-secondary-button
                                class="mt-4"
                                [text]="'Delete' | translate"
                                (onClick)="removeSection.emit(index)">
                        </app-secondary-button>
                        <app-primary-button
                                class="mt-4"
                                [text]="'Save' | translate"
                                (onClick)="removeSection.emit(index)">
                        </app-primary-button>
                    </div>
                </div>
                <!-- The section selection grid: -->
                <white-label-section-selector
                        [index]="index"
                        (openType)="openSectionSubTypes(index, $event.type, $event.subType)">
                </white-label-section-selector>
            }
        }


        <!-- Bottom controls (if you want a "+" below the section) -->
        <white-label-section-controls
                *ngIf="index < (pageBuilderStore?.page?.sections?.length - 1) && editMode"
                [index]="index"
                (add)="addSection.emit($event)"
                [position]="'bottom'">
        </white-label-section-controls>
    } @else {
        @switch (section.component){
            @case (componentTypes.hero) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" >
                    <app-header-stats-banner-component [componentModel]="section.data"></app-header-stats-banner-component>
                </app-section-component>
            }
            @case (componentTypes.banner_left_right) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-banner-left-right-component [componentModel]="section.data"></app-banner-left-right-component>
                </app-section-component>
            }


            @case (componentTypes.hero_live_stream) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-hero-banner-live-stream [componentModel]="section.data" [section] = "section"></app-hero-banner-live-stream>
                </app-section-component>
            }
            @case (componentTypes.hero_simple_app) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-hero-banner-simple [componentModel]="section.data"></app-hero-banner-simple>
                </app-section-component>
            }
            @case (componentTypes.hero_product) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-hero-banner-product [componentModel]="section.data"></app-hero-banner-product>
                </app-section-component>
            }
            @case (componentTypes.hero_slider) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-hero-slider-banner [componentModel]="section.data"></app-hero-slider-banner>
                </app-section-component>
            }
            @case (componentTypes.hero_video) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto" >
                    <app-hero-video-banner [componentModel]="section.data"></app-hero-video-banner>
                </app-section-component>
            }



            @case (componentTypes.banner_right_left) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-banner-right-left-component [componentModel]="section.data"></app-banner-right-left-component>
                </app-section-component>
            }
            @case (componentTypes.sponsor) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-sponsors-component [componentModel]="section.data"></app-sponsors-component>
                </app-section-component>
            }
            @case (componentTypes.faq) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-dropdown-faq [componentModel]="section.data"></white-label-dropdown-faq>
                </app-section-component>
            }
            @case (componentTypes.latestProducts) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-store-preview [componentModel]="section.data"></app-store-preview>
                </app-section-component>
            }
            @case (componentTypes.text) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-text-reach-editor [componentModel]="section.data" [isEditing]="section === pageBuilderStore.sectionData"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.reviews) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-reviews-component [componentModel]="section.data"></app-reviews-component>
                </app-section-component>
            }
            @case (componentTypes.externalCode) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-text-reach-editor [componentModel]="section.data" [isEditing]="section === pageBuilderStore.sectionData"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.contactUs) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-contact-component [componentModel]="section.data"></app-contact-component>
                </app-section-component>
            }
            @case (componentTypes.aiComponent) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-text-reach-editor [componentModel]="section.data"></white-label-text-reach-editor>
                </app-section-component>
            }
            @case (componentTypes.pricing) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-pricing-component [componentModel]="section.data"></app-pricing-component>
                </app-section-component>
            }
            @case (componentTypes.stats) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-statistics [componentModel]="section.data"></white-label-statistics>
                </app-section-component>
            }
            @case (componentTypes.how_it_works) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-how-it-works [componentModel]="section.data"></white-label-how-it-works>
                </app-section-component>
            }
            @case (componentTypes.horizontalCarousel) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-horizontal-card-carousel [componentModel]="section.data"></white-label-horizontal-card-carousel>
                </app-section-component>
            }
            @case (componentTypes.grid) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <white-label-grid [componentModel]="section.data"></white-label-grid>
                </app-section-component>
            }
            @case (componentTypes.donationWidget) {
                <app-section-component [editMode]="editMode" (removeSection)="removeSection.emit($event)" [componentData]="section" class=" m-auto">
                    <app-donation-widget ></app-donation-widget>
                </app-section-component>
            }
            @default {
            }
        }
    }
</section>
